import { KeyboardEvent, useCallback, useEffect } from 'react';

export const useEnterKey = (onEnterPress: () => void | Promise<void>) => {
  const handleKeyPress = useCallback(
    (event: KeyboardEvent | globalThis.KeyboardEvent) => {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        onEnterPress();
      }
    },
    [onEnterPress]
  );

  return { enterKeyHandler: handleKeyPress };
};

export const useEnterKeyGlobal = (onEnterPress: () => void | Promise<void>) => {
  const { enterKeyHandler } = useEnterKey(onEnterPress);

  useEffect(() => {
    document.addEventListener('keypress', enterKeyHandler as EventListener);
    return () => {
      document.removeEventListener('keypress', enterKeyHandler as EventListener);
    };
  }, [enterKeyHandler]);
};
